export default __webpack_public_path__ + "static/media/gudipati-venkata-sarojini.74c418eb.png";